import * as PropTypes from "prop-types";
import {filterValueInterface} from "./filterInterface";
import {featureInterface} from "./featureInterface";

// ITEM -> GROUP
// ITEM -> GROUP -> SECTION -> STEP // not used

export const WIZARD_GROUP_TYPES = {
  group: "group",
  filter: "filter",
  custom: "custom",
}

export const wizardGroupInterface = {
  id: PropTypes.string.isRequired,
  nodeType: PropTypes.oneOf(Object.keys(WIZARD_GROUP_TYPES)).isRequired,
  groupName: PropTypes.string.isRequired,
  filterGroupId: PropTypes.number,
  scopeImageUrl: PropTypes.string,
  customDisplayName: PropTypes.string,
  enabled: PropTypes.bool.isRequired,
  title: PropTypes.string,
  description: PropTypes.string,
  featuresExcluded: PropTypes.array,
  featuresIncluded: PropTypes.array,
  useIncluded: PropTypes.bool,
  filtersExcluded: PropTypes.array,
  productCartTitle: PropTypes.string,
  productCartDescription: PropTypes.string,
  uploadedImageUrl: PropTypes.string,
  noAvailableFilters: PropTypes.bool,
  notRequired: PropTypes.bool,
  mergedGroups: PropTypes.array, // same parent logic
  wizardGroupIcon: PropTypes.string,
  hideInCartAndReceipt: PropTypes.bool,
  multipleAddToCart: PropTypes.bool,
  inputFields: PropTypes.array, // {id: "", checked: bool, oneLine: bool}
  headerTitle: PropTypes.string, // {id: "", checked: bool}
  headerSubTitle: PropTypes.string, // {id: "", checked: bool}
  visibleInVisualizers: PropTypes.array, //["kitchen", "laundryroom", etc]
  hideForCustomers: PropTypes.bool, // eyeball
  skipProductInfo: PropTypes.bool,
  hidePriceNoCart: PropTypes.bool,
  skipLockDontApply: PropTypes.bool,
  dontMatchFeaturesBySku: PropTypes.bool,
  colorFiltersDisabled: false,
  notePlaceholder: PropTypes.string,
  defaultWizardQuantity: PropTypes.oneOfType([PropTypes.number, PropTypes.string]), // should be string
  useCustomDefaultQuantity: PropTypes.bool,
};

export const wizardNodeInterface = {
  id: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  position: PropTypes.object.isRequired,
  style: PropTypes.object,
  data: PropTypes.shape({
    wizardGroup: PropTypes.shape(wizardGroupInterface)
  }),
};

export const wizardEdgeInterface = {
  id: PropTypes.string.isRequired,
  source: PropTypes.string.isRequired,
  target: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
};

export const wizardItemInterface = {
  id: PropTypes.number,
  uniqueHashId: PropTypes.string,
  visualizer: PropTypes.string,
  name: PropTypes.string,
  description: PropTypes.string,
  customImageUrl: PropTypes.string,
  uploadedImageUrl: PropTypes.string,
  enabled: PropTypes.bool,
  hideItems: PropTypes.bool,
  selected: PropTypes.bool,
  // wizardSteps: PropTypes.arrayOf(PropTypes.shape(wizardStepInterface)),
  // wizardSections: PropTypes.arrayOf(PropTypes.shape(wizardSectionInterface)),
  wizardGroups: PropTypes.arrayOf(PropTypes.shape(wizardGroupInterface)),
  wizardNodes: PropTypes.arrayOf(PropTypes.shape(wizardNodeInterface)),
  wizardEdges: PropTypes.arrayOf(PropTypes.shape(wizardEdgeInterface)),
  disabledScenes: PropTypes.arrayOf(PropTypes.number),
  startTitle: PropTypes.string,
  startDescription: PropTypes.string,
  colorFiltersFullyDisabled: false,
  hideForQuoting: false,
  openFromContextForGroups: PropTypes.arrayOf(PropTypes.shape({groupName: PropTypes.string})),
};

export const wizardQuantityFeatureInterface = {
  quanFeature: PropTypes.shape(featureInterface),
  quantity: PropTypes.number,
};

export const wizardSelectedValueInterface = {
  partId: PropTypes.string,
  wizardGroup: PropTypes.shape(wizardGroupInterface),
  selectedFilter: PropTypes.shape(filterValueInterface),
  selectedFeature: PropTypes.shape(featureInterface),
  quantity: PropTypes.number,
  singleFeature: PropTypes.bool,
  quantityItems: PropTypes.arrayOf(PropTypes.shape(wizardQuantityFeatureInterface)), // for multiple add
};

export const wizardAllObjectInterface = {
  quoteIndex: PropTypes.number.isRequired,
  lastVisitedStep: PropTypes.number,
  isLastActiveWizard: PropTypes.bool,
  wizardItemId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  uniqueHashId: PropTypes.string,
  visualizer: PropTypes.string, // common name, same as in the wizard item
  wizardSelectedValues: PropTypes.object, // {0: wizardSelectedValueInterface, 1: wizardSelectedValueInterface}
};

export const wizardConflictingObjectInterface = {
  stepIndex: PropTypes.number.isRequired,
  wizardGroupId: PropTypes.string.isRequired,
  cartItemId: PropTypes.string.isRequired
}
